import graphql from 'graphql-tag'
import client from '@stores/apollo'
import { IEdge, IPageInfo, ITag } from '@api/types'

interface EmployeeTagsConnection {
  pageInfo: IPageInfo
  edges: IEdge<ITag>[]
}

export interface Payload {
  data: {
    viewer: {
      company: {
        assetTags: EmployeeTagsConnection
      }
    }
  }
}

export default function fetch({
  query,
  after,
}: {
  query: string
  after?: string
}): Promise<EmployeeTagsConnection> {
  const variables = { query, after }
  return client.gql.query({ query: tagsGroupSearchQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { assetTags },
        },
      },
    }: Payload) => assetTags
  )
}
const tagsGroupSearchQuery = graphql`
  query AssetTagsSearch($query: String!, $after: String) {
    viewer {
      company {
        assetTags(first: 7, after: $after, orderBy: name_ASC, where: { name_contains: $query }) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`
